import { Home } from '../homepage';

export default Home;
